import {
    IS_LOADING,
    SET_DISPLAY_ENDED_INTERVENTIONS,
    SET_DISPLAY_INTERVENTIONS_WITHOUT_CERFA,
    SET_FILTERED_AND_SORTED_INTERVENTIONS,
    SET_INTERVENTIONS,
    SET_SELECTED_TYPE,
    SET_SELECTED_STATE,
    SET_END_DATE,
    SET_START_DATE,
    NB_MAX_PLANNED_INTERVENTION_TO_DISPLAY,
    SET_DISPLAY_AS_LIST,
    SET_CURRENT_INTERVENTION,
    SET_ATTACHMENTS,
} from './extranetInterventionConstants';
import { throwErrorMessage } from '../../lib/error_helper';
import { fetchWithTimeout } from '../../lib/fetch_wrapper';
import { adaptInterventionForMyOpen } from './extranetInterventionCast'
import { setNbTotalResults } from '../contextInfos/contextInfosActions'
import { ALL_SELECT_OPTION } from '../../constants';
import { getSiteIds } from '../customerSite/customerSiteActions';
import { downloadFile, sortListOfTableBy } from '../../utils';
import { MODULE_EXTRANET_INTERVENTIONS } from '../authorizedApps/authorizedAppsConstants';

export function interventionsIsLoading(value) {
    return {
        type: IS_LOADING,
        info: 'interventions',
        isLoading: value
    };
}

export function setDisplayInterventionsWithoutCerfaAction(displayInterventionsWithoutCerfa) {
    return {
        type: SET_DISPLAY_INTERVENTIONS_WITHOUT_CERFA,
        displayInterventionsWithoutCerfa,
    }
}

export function setDisplayEndedInterventionsAction(displayEndedInterventions) {
    return {
        type: SET_DISPLAY_ENDED_INTERVENTIONS,
        displayEndedInterventions,
    }
}

export function setSelectedTypeAction(selectedType) {
    return {
        type: SET_SELECTED_TYPE,
        selectedType,
    }
}

export function setSelectedStateAction(selectedState) {
    return {
        type: SET_SELECTED_STATE,
        selectedState,
    }
}

export function setEndDateAction(endDate) {
    return {
        type: SET_END_DATE,
        endDate,
    }
}

export function setStartDateAction(startDate) {
    return {
        type: SET_START_DATE,
        startDate,
    }
}

export function setFilteredAndSortedInterventionsAction(filteredAndSortedInterventions) {
    return {
        type: SET_FILTERED_AND_SORTED_INTERVENTIONS,
        filteredAndSortedInterventions,
    }
}

export function setInterventionsAction(interventions) {
    return {
        type: SET_INTERVENTIONS,
        interventions,
    }
}

export function setCurrentInterventionAction(intervention) {
    return {
        type: SET_CURRENT_INTERVENTION,
        intervention,
    }
}

export function setDisplayAsListAction(displayAsList) {
    return {
        type: SET_DISPLAY_AS_LIST,
        displayAsList,
    }
}

export function setAttachmentsAction(attachments) {
    return {
        type: SET_ATTACHMENTS,
        attachments,
    }
}

export function loadPlannedInterventions(user, customerSiteId, allSites, interventionsFilters, nbTotalResults) {
    return (dispatch) => {
        let tableState = {
            pageSize: NB_MAX_PLANNED_INTERVENTION_TO_DISPLAY,
            pageNumber: 0,
        }

        dispatch(setFilteredAndSortedInterventions(interventionsFilters, null, null, tableState, user, customerSiteId, allSites, nbTotalResults))
    }
}

export function loadIntervention(intervention, user) {
    return (dispatch) => {
        dispatch(setCurrentInterventionAction(intervention));
        if (intervention)
            dispatch(getAttachments(intervention, user))
    }
}

export function getAndLoadIntervention(intervention, user, onSuccess) {
    return (dispatch) => {

        dispatch(interventionsIsLoading(true));

        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/interventions/get_work_order/', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                interventionId: intervention.id,
                userId: user.id,
            })
        })
            .then((response) => {
                if (!response.ok)
                    throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(intervention => {
                dispatch(loadIntervention(adaptInterventionForMyOpen(intervention), user));

                if (onSuccess && typeof onSuccess === "function")
                    onSuccess();

                dispatch(interventionsIsLoading(false));
            }).catch((err) => {
                console.error("Erreur : extranetInterventionActions - getAndLoadIntervention", err);
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération de l'intervention !",
                }))
                dispatch(interventionsIsLoading(false));
            });
    }
}

export function setFilteredAndSortedInterventions(interventionsFilters, componentPark, affair, tableState, user, customerSiteId, allSites, nbTotalResults) {
    return (dispatch) => {

        if (!customerSiteId)
            return;

        dispatch(interventionsIsLoading(true));
        let customerSiteIds = getSiteIds(customerSiteId, allSites);

        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/interventions/get_work_orders_of_customer/', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                customerSiteIds,
                userId: user.id,
                pageSize: tableState.pageSize,
                pageNumber: tableState.pageNumber,
                selectedState: !interventionsFilters || interventionsFilters.selectedState === ALL_SELECT_OPTION ? null : interventionsFilters.selectedState,
                selectedType: !interventionsFilters || interventionsFilters.selectedType === ALL_SELECT_OPTION ? null : interventionsFilters.selectedType,
                startDate: interventionsFilters && interventionsFilters.startDate ? interventionsFilters.startDate.utc().format('YYYY-MM-DD HH:mm:ss') : null,
                endDate: interventionsFilters && interventionsFilters.endDate ? interventionsFilters.endDate.utc().format('YYYY-MM-DD HH:mm:ss') : null,
                displayInterventionsWithoutCerfa: interventionsFilters ? interventionsFilters.displayInterventionsWithoutCerfa : true,
                displayEndedInterventions: interventionsFilters ? interventionsFilters.displayEndedInterventions : true,
                ids: componentPark ? componentPark.work_order_ids.map(wo => wo.id) : null,
                affairId: affair ? affair.id : null,
            })
        })
            .then((response) => {
                if (!response.ok)
                    throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(result => {
                let allInterventions = [];

                customerSiteIds.forEach(s => {
                    allInterventions = allInterventions.concat(result.interventions[s])
                })

                let transformedInterventions = allInterventions.map(i => adaptInterventionForMyOpen(i));
                dispatch(setNbTotalResults(nbTotalResults, MODULE_EXTRANET_INTERVENTIONS, result.nbTotalInterventions));
                transformedInterventions = sortListOfTableBy(tableState.orderBy, tableState.descOrder, transformedInterventions);
                dispatch(setFilteredAndSortedInterventionsAction(transformedInterventions));
                dispatch(interventionsIsLoading(false));
            }).catch((err) => {
                console.error("Erreur : extranetInterventionActions - setFilteredAndSortedInterventions", err);
                dispatch(setNbTotalResults(nbTotalResults, MODULE_EXTRANET_INTERVENTIONS, 0));
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération des interventions !",
                }))
                dispatch(interventionsIsLoading(false));
            });
    }
}

export function setSelectedType(value) {
    return (dispatch) => {
        dispatch(setSelectedTypeAction(value));
    }
}

export function setSelectedState(value) {
    return (dispatch) => {
        dispatch(setSelectedStateAction(value));
    }
}

export function setStartDate(value) {
    return (dispatch) => {
        dispatch(setStartDateAction(value));
    }
}

export function setEndDate(value) {
    return (dispatch) => {
        dispatch(setEndDateAction(value));
    }
}

export function setDisplayInterventionsWithoutCerfa(value) {
    return (dispatch) => {
        dispatch(setDisplayInterventionsWithoutCerfaAction(value));
    }
}

export function setDisplayEndedInterventions(value) {
    return (dispatch) => {
        dispatch(setDisplayEndedInterventionsAction(value));
    }
}

export function setDisplayAsList(value) {
    return (dispatch) => {
        dispatch(setDisplayAsListAction(value));
    }
}

export function getStates() {
    return [
        "open",
        "assigned",
        "performed",
        "job_finished",
        "tech_report_integrated",
        "report_generated",
        "report_sent",
        "done",
        "cna_validation",
        "waiting_for_invoice",
        "closed"
    ];
}

export function getFilterStates() {
    return [
        "open",
        "performed",
        "done",
    ];
}

export function getTypes() {
    return [
        'fixing',
        'inspection',
        'quote_execution',
        'on_call',
        'commissioning'
    ];
}

export function clearIntervention() {
    return (dispatch) => {
        dispatch(loadIntervention(null))
    }
}

export function getAttachments(intervention, user) {
    return (dispatch) => {
        dispatch(interventionsIsLoading(true));

        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/interventions/get_work_orders_attachments/', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                interventionId: intervention.id,
                userId: user.id,
            })
        })
            .then((response) => {
                if (!response.ok)
                    throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(attachments => {
                dispatch(setAttachmentsAction(attachments));
                dispatch(interventionsIsLoading(false));
            }).catch((err) => {
                console.error("Erreur : extranetInterventionActions - getAttachments", err);
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération des pièces jointes !",
                }))
                dispatch(interventionsIsLoading(false));
            });
    }
}

export function downloadAttachment(attachment, user) {
    return (dispatch) => {
        dispatch(interventionsIsLoading(true));

        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/interventions/download_attachment/', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                attachmentId: attachment.id,
                userId: user.id,
            })
        })
            .then((response) => {
                if (!response.ok)
                    throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(attachment => {
                if (!attachment || !attachment.datas) {
                    dispatch(interventionsIsLoading(false));
                    return;
                }

                var dataURI = "data:application/pdf;base64," + attachment.datas;
                downloadFile(dataURI, attachment.datas_fname ? attachment.datas_fname : "Pièce jointe");
                dispatch(interventionsIsLoading(false));
            }).catch((err) => {
                console.error("Erreur : extranetInterventionActions - downloadAttachment", err);
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors du téléchagement de la pièce jointe !",
                }))
                dispatch(interventionsIsLoading(false));
            });
    }
}
